import { FilterState } from './deviceGroupFilterTypes';

export const filterStateDefault: FilterState = { noDevices: false, noUserGroups: false };
